import { Badge } from '../ui/badge';

const STATUS_CONFIGS = {
  ocorrencia: {
    agendada: { label: 'Agendada', className: 'bg-blue-100 text-blue-700' },
    em_andamento: { label: 'Em Andamento', className: 'bg-orange-100 text-orange-700 animate-pulse' },
    realizada: { label: 'Realizada', className: 'bg-green-100 text-green-700' },
    cancelada: { label: 'Cancelada', className: 'bg-gray-100 text-gray-500' },
  },
  tarefa: {
    aberta: { label: 'Aberta', className: 'bg-yellow-100 text-yellow-700' },
    em_andamento: { label: 'Em Andamento', className: 'bg-blue-100 text-blue-700' },
    concluida: { label: 'Concluída', className: 'bg-green-100 text-green-700' },
    atrasada: { label: 'Atrasada', className: 'bg-red-100 text-red-700' },
  },
  prioridade: {
    baixa: { label: 'Baixa', className: 'bg-gray-100 text-gray-600' },
    media: { label: 'Média', className: 'bg-blue-100 text-blue-600' },
    alta: { label: 'Alta', className: 'bg-orange-100 text-orange-600' },
    critica: { label: 'Crítica', className: 'bg-red-100 text-red-700' },
  },
  aprovacao: {
    pendente: { label: 'Pendente', className: 'bg-yellow-100 text-yellow-700' },
    aprovada: { label: 'Aprovada', className: 'bg-green-100 text-green-700' },
    revisao: { label: 'Em Revisão', className: 'bg-orange-100 text-orange-700' },
  },
};

export const StatusBadge = ({ status, type = 'ocorrencia' }) => {
  const config =
    STATUS_CONFIGS[type]?.[status] || { label: status, className: 'bg-gray-100 text-gray-600' };
  return <Badge className={config.className}>{config.label}</Badge>;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('pt-BR');
};

export const isPast = (dateStr) => {
  if (!dateStr) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const date = new Date(dateStr + 'T00:00:00');
  return date < today;
};

export const isNear = (dateStr) => {
  if (!dateStr) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const date = new Date(dateStr + 'T00:00:00');
  const diffDays = Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  return diffDays >= 0 && diffDays <= 7;
};
